import {Box} from "@mui/system";
import {Grid, Link, Typography} from "@mui/material";
import importedStyles from './styles';

export default function CurvedFooter() {
    return(
        <Box sx={styles.curveRoot}>
            <Box sx={styles.contentContainer}>
                <Box sx={styles.container}>
                    <Grid container sx={styles.parentGrid}>
                        <Grid item md={5} sm={12} xs={12} sx={{ ...styles.gridItemLeft, marginBottom: { xs: '15px', md: 0 } }}>
                            <Link href={'https://www.beremarkable.ai'} target="_blank" sx={styles.websiteLink}>
                                BeRemarkable.AI
                            </Link>
                        </Grid>

                        <Grid item md={5} sm={12} xs={12} sx={styles.gridItemRight}>
                            <Box sx={styles.leftTextContainer}>
                                <Typography sx={styles.remarkableText}>
                                    &copy; {new Date().getFullYear()} Remarkable
                                </Typography>
                                <Box sx={styles.legalTextContainer}>
                                    <Link href={'https://www.beremarkable.ai/legal/privacy-policy'} target="_blank" sx={{ ...styles.legalLink, marginRight: { md: '20px', xs: '0px' }, mb: { md: 0, xs: '10px' } }}>
                                        Privacy Policy
                                    </Link>
                                    <Link href={'https://www.beremarkable.ai/legal/terms'} target="_blank" sx={styles.legalLink}>
                                        Terms of Service
                                    </Link>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </Box>
    )
}

const styles = {
    curveRoot: {
        width: '100%',
        height: {xs: '270px', md: '200px'},
        position: 'absolute',
        bottom: 0,
        overflow: "hidden",
        backgroundColor: "#302e2a",
        "&::before": {
            content: '""',
            position: "absolute",
            left: '-10%',
            width: "120%",
            backgroundColor: "#edede4",
            borderRadius: "0 0 50% 50%",
            top: { xs: "-200px", md: "-355px" },
            height: { xs: "300px", md: "460px" },
        },
    },
    contentContainer: {
        width: '100%',
        backgroundColor: '#302e2a',
        position: 'absolute',
        bottom: 0,
        color: '#edede4',
        mb: { xs: '30px', md: '20px' }
    },
    container: {
        ...importedStyles.container
    },
    parentGrid: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    leftTextContainer: {
        textAlign: { xs: 'left', md: 'right' },
        display: 'flex',
        flexDirection: { md: 'column', xs: 'column-reverse' },
        justifyContent: 'space-between'
    },
    gridItemLeft: {
        display: 'flex',
        alignItems: 'center',
        textAlign: { xs: 'left', md: 'left' }
    },
    gridItemRight: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: { xs: 'flex-start', md: 'flex-end' }
    },
    remarkableText: {
        color: '#7c7a74',
        fontFamily: 'FustatRegular',
        fontSize: '12px',
        margin: 0,
        pt: {xs: '10px', md: 0},
        pb: {xs: 0, md: '5px'},
        textAlign: {xs: 'left', md: 'right'}
    },
    legalTextContainer: {
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        justifyContent: { xs: 'flex-start', md: 'flex-end' },
        alignItems: { xs: 'flex-start', md: 'center' },
        margin: 0,
        padding: 0
    },
    websiteLink: {
        color: '#edede4',
        fontFamily: 'AzeretMonoRegular',
        fontSize: '10px',
        textDecoration: 'none',
        '&:hover': {
            color: '#edede4',
        },
        '&:active': {
            color: '#a0a096',
        },
        '&:focus': {
            color: '#edede4',
            outline: 'none',
        },
    },
    legalLink: {
        color: '#a1a19a',
        fontFamily: 'FustatRegular',
        fontSize: '12px',
        textDecoration: 'none',
        '&:hover': {
            color: '#edede4',
        },
        '&:active': {
            color: '#a0a096',
        },
        '&:focus': {
            color: '#edede4',
            outline: 'none',
        },
    }
}